import Vue from 'vue';

import axios from 'axios';
import queryString from 'query-string';
import actions from '../actions/compApproval';

export default {
	namespaced: true,
	state: {
		competitions: null,
		links: [],
		paginationMetadata: {},
		competition: null,
	},
	mutations: {
		[actions.SET_DATA]: (state, data) => {
			state.links = data.links;
			state.competitions = data.entities;
			state.paginationMetadata = data.paginationMetadata;
		},
		[actions.SET_LINK]: (state, data) => {
			state.links = data.links;
		},
		[actions.REMOVE_DATA]: (state) => {
			state.links = [];
			state.competitions = [];
			state.paginationMetadata = {};
		},
		[actions.REMOVE_COMPETITION]: (state) => {
			state.competitions = [];
		},
		[actions.SET_COMPETITION]: (state, data) => {
			state.competition = data;
		},
		[actions.ENRICH_COMPETITION]: (state, data) => {
			const key = state.competitions.findIndex(x => x.id === data.id);
			Vue.set(state.competitions, key, data);
		},
	},
	actions: {
		[actions.GET_COMP_APPROVAL_LINKS]: async ({ commit, rootState }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'competition_approval_links');

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_LINK, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.NEW_COMP_APPROVAL]: async (context, { newCompApproval, link }) => {
			try {
				const response = await axios.post(link.href, newCompApproval);
				const { data } = response;
				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.UPDATE_COMP_APPROVAL]: async (context, { newCompApproval, link, cGuid }) => {
			try {
				const href = link.href.replace('{id}', cGuid);
				await axios.put(href, newCompApproval);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_COMP_BY_ID]: async ({ commit }, { link, cGuid }) => {
			try {
				const href = link.href.replace('{id}', cGuid);
				const response = await axios.get(href);

				const { data } = response;

				commit(actions.SET_COMPETITION, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_COMP_APPROVAL_LIST]: async ({ commit }, { link, oGuid, queryParameters }) => {
			try {
				const queryTemplatePos = link.href.indexOf('{?');
				const queryTemplate = link.href
					.substring(queryTemplatePos, link.href.length);

				const href = link.href
					.replace('{organizationId}', oGuid)
					.replace(queryTemplate, `?${queryString.stringify(queryParameters)}`);

				const response = await axios.get(href);

				const { data } = response;

				commit(actions.SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.FETCH_COMP_APPROVAL_LIST]: async ({ commit }, link) => {
			try {
				commit(actions.REMOVE_DATA);

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_COMPETITION_BY_GUID]: async ({ commit }, { link, cGuid }) => {
			try {
				const href = link.href
					.replace('{id}', cGuid);

				const response = await axios.get(href);

				const { data } = response;
				commit(actions.ENRICH_COMPETITION, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.REQUEST_COMP_APPROVAL]: async (context, { link, cGuid }) => {
			try {
				const href = link.href
					.replace('{id}', cGuid);

				await axios.post(href);
			} catch (error) {
				throw error;
			}
		},
		[actions.SEND_ATTACHMENT]: async (context, { link, cGuid, upload }) => {
			try {
				const href = link.href
					.replace('{id}', cGuid);

				await axios.post(href, upload);
			} catch (error) {
				throw error;
			}
		},
		[actions.SEND_APPROVAL_UPDATE]: async (context, {
			link, cGuid, oGuid, update,
		}) => {
			try {
				const href = link.href
					.replace('{competitionId}', cGuid)
					.replace('{organizationId}', oGuid);

				await axios.post(href, update);
			} catch (error) {
				throw error;
			}
		},
		[actions.SEND_APPROVAL_CANCELLATION]: async (context, {
			link, cGuid, reason,
		}) => {
			try {
				const href = link.href
					.replace('{id}', cGuid);

				await axios.post(href, { cancelationReason: reason });
			} catch (error) {
				throw error;
			}
		},
		[actions.SEND_FINISHER]: async (context, {
			link, cGuid, finisher,
		}) => {
			try {
				const href = link.href
					.replace('{id}', cGuid);

				await axios.put(href, finisher);
			} catch (error) {
				throw error;
			}
		},
		[actions.COPY_COMP_APPROVAL]: async (context, { link, cGuid }) => {
			try {
				const href = link.href
					.replace('{id}', cGuid);

				const response = await axios.post(href);

				const { data } = response;
				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.DELETE_ATTACHEMENT]: async (context, { link, cGuid }) => {
			try {
				const href = link.href
					.replace('{id}', cGuid);

				await axios.delete(href);
			} catch (error) {
				throw error;
			}
		},
		[actions.DELETE_COMPETITION]: async (context, { link, cGuid }) => {
			try {
				const href = link.href
					.replace('{id}', cGuid);

				await axios.delete(href);
			} catch (error) {
				throw error;
			}
		},
		[actions.CREATE_RECEIPT]: async ({ commit }, { link, cGuid }) => {
			try {
				const href = link.href.replace('{id}', cGuid);
				const response = await axios.get(href);

				const { data } = response;
				return data;
			} catch (error) {
				throw error;
			}
		},
	},
	getters: {
		CompApprLinks: state => state.links,
		Pagination: state => state.paginationMetadata,
		Competition: state => state.competition,
		Competitions: state => state.competitions,
	},
};
